// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import { ContentModule } from "../../common/content_module/ContentModule";
import { reaction } from "mobx";
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";
import { CwTextBildModule } from "../../common/cw_text_bild_module/CwTextBildModule";
import { Product } from "../../../common/interfaces/conversionworld/Product";
import { Api } from "../../../api";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    CwTextBildModule,
  },
})
export class ProductAdvantagesModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object): string {
    let color = "white";

    if (this.currentProduct) {
      color = this.currentProduct.is_van_solution ? "black" : "white";
    }

    if (instance["color"]) {
      color = instance["color"];
    }

    return color;
  }

  get currentProduct() {
    return this.$store.conversionWorldProduct.current;
  }

  get textBildInstance() {
    // Color
    let color = "white";
    if (this.currentProduct && this.currentProduct.is_van_solution) {
      color = "black";
    }
    if (
      this.instance["optional"]["bgcolor"] &&
      this.instance["optional"]["bgcolor"] !== "-"
    ) {
      color = this.instance["optional"]["bgcolor"];
    }

    let text = "";
    // Beschreibungstext
    if (
      this.currentProduct &&
      this.currentProduct.product_equipment_description &&
      this.currentProduct.product_equipment_description.length > 0
    ) {
      text += '<div class="cw-typo--typo6 mar-bottom-lg">';
      text += this.instance["translation"]["headline_description"];
      text += "</div>";

      text += '<p class="mar-bottom-lg">';
      text += this.currentProduct.product_equipment_description;
      text += "</p>";
    }

    // Vorteile Text
    if (
      this.instance["optional"]["advantages"] &&
      this.instance["optional"]["advantages"].length > 0
    ) {
      text += this.instance["optional"]["advantages"];
    } else if (
      this.currentProduct &&
      this.currentProduct.product_advantages &&
      this.currentProduct.product_advantages.length > 0
    ) {
      text += '<div class="cw-typo--typo6">';
      text += this.instance["translation"]["headline_vorteile"];
      text += "</div>";
      text += '<ul class="list--plus">';
      this.currentProduct.product_advantages.forEach((s) => {
        text += "<li>" + s + "</li>";
      });
      text += "</ul>";
    }

    // Images
    let images: object[] = [];
    if (
      this.instance["optional"]["images"] &&
      this.instance["optional"]["images"].length > 0
    ) {
      this.instance["optional"]["images"].forEach((image) => {
        images.push({
          enlarge: true,
          video: null,
          text: image["text"],
          image: {
            de: {
              medium: image["images"][this.lang]["medium"],
              large: image["images"][this.lang]["large"],
              xlarge: image["images"][this.lang]["xlarge"],
              full: image["images"][this.lang]["xlarge"],
            },
          },
        });
      });
    } else if (this.currentProduct && this.currentProduct.visuals.length > 0) {
      this.currentProduct.visuals.forEach((visual) => {
        images.push({
          image: visual.is_video
            ? null
            : {
                de: {
                  medium: visual.medium,
                  large: visual.large,
                  xlarge: visual.xlarge,
                  full: visual.xlarge,
                },
              },
          enlarge: true,
          video: visual.is_video ? visual.video_data : null,
          text: visual.description,
        });
      });
    }

    if (images.length < 3) {
      images = [];
    } else if (images.length === 5) {
      images = images.slice(0, 4);
    } else if (images.length > 6) {
      images = images.slice(0, 6);
    }

    // Common Options
    let commonOptions = this.instance["common_options"];
    if (commonOptions["margin-top"] == "") {
      commonOptions["margin-top"] = "40";
    }

    return {
      color,
      headline: {
        type: "h2",
        text: this.instance["translation"]["headline"],
      },
      subline: this.instance["translation"]["subheadline"],
      text: text,
      footer: this.instance["optional"]["footer"],
      images: images,
      common_options: commonOptions,
    };
  }
}
